/**
 * @generated SignedSource<<b98c606375d20614a10f78e632506573>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type User_Account_Integrations$data = {
  readonly account: {
    readonly id: number;
    readonly " $fragmentSpreads": FragmentRefs<"Account_Integrations">;
  };
  readonly " $fragmentType": "User_Account_Integrations";
};
export type User_Account_Integrations$key = {
  readonly " $data"?: User_Account_Integrations$data;
  readonly " $fragmentSpreads": FragmentRefs<"User_Account_Integrations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "User_Account_Integrations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Account_Integrations"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "79e52cb8ed60a38220ed7e85369dd09d";

export default node;
